module.exports = {
    accessibility:{
        aria:{
            toolbar: "Ask Julie Toolbar",
        },
    },
};


// WEBPACK FOOTER //
// ./settings/accessibility.js